<script lang="ts">
  /* @NOTE:-
    Only use this component on the +page.svelte, so we don't get overlapping meta headers
  */
  import AltComponent from "./alt.svelte";
  import CustomComponent from "./custom.svelte";
  import DefaultComponent from "./default.svelte";
  import { MetaType } from "./meta-utils";
  import type { Meta } from "types/backend/models/cms/meta.entity";

  export let meta: Meta[] = [];
</script>

<svelte:head>
  {#each meta as row (`${row.title}-${row.type}-${row.metaType}-${row.description}`)}
    {@const { metaType } = row}
    {#if !metaType || metaType === MetaType.default}
      <DefaultComponent meta={row} />
    {:else if metaType === MetaType.alternate}
      <AltComponent meta={row} />
    {:else if metaType === MetaType.custom}
      <CustomComponent meta={row} />
    {/if}
  {/each}
</svelte:head>
